import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { ref, getDownloadURL } from 'firebase/storage'
import { fstorage } from '../../utils/firebase'
import { Title, Description, FurtherDesc } from '../common/System'
import LoadInView from '../common/LoadInView'
import Arrow from '../../img/arrow.webp'

const Visualize = () => {
    const [upperLevel, setUpperLevel] = useState('')
    const [view, setView] = useState('')
    const [url, setUrl] = useState('')
    const [show, setShow] = useState(false)

    const formUpperHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setUpperLevel(e.target.value)
    }

    const formHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setView(e.target.value)
    }

    useEffect(() => {
        getDownloadURL(ref(fstorage, `system/html_${view}2.html`))
            .then((url: string) => {
                console.log(url)
                setUrl(url)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [view])

    const handleShow = () => {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }        

  return (
    <Wrapper>
        <Title>시각화 결과 확인하기</Title>
        <Description>
            <div>학문프로파일 데이터를 word2vec으로 학습하고, 그 결과를 2차원으로 시각화한 것입니다.</div>
            <div>PC에서 활용하는 것을 권장합니다.</div>
            <ul>
                <li>@created: 23.09.26</li>
                <li>@updated: 23.09.29</li>
            </ul>
        </Description>
        <FurtherDesc isShow={show}>
            <div onClick={handleShow}>
                <img src={Arrow} alt="arrow"/>
                상세 절차보기
            </div>
                {show?
                    <LoadInView>
                        <ol type="1">
                            <li>학과 단위로 학문프로파일 데이터 병합</li>
                            <li>사전학습된 word2vec에 업데이트함</li>
                            <li>모델 훈련</li>
                            <li>모델에 따라 학과 벡터 계산</li>
                            <li>학과벡터(200차원)을 t-SNE 활용하여 2차원 시각화</li>
                            <li>결과 제시</li>
                        </ol>
                    </LoadInView>
                    : <div></div>
                }
        </FurtherDesc>
        <div>
            <select name="상위범주" onChange={(e) => formUpperHandler(e)}>
                <option value="1">선택하기</option>
                <option value="2">학과별로 보기</option>
                <option value="3">영역별로 보기</option>
                <option value="4">중요문항 보기</option>
            </select>
            {upperLevel === '2'?
                <select name="시각화" onChange={(e) => formHandler(e)}>
                    <option value="1">선택하기</option>
                    <option value="전체1">전체: 문이예</option>
                    <option value="전체2">전체: 인사자..</option>
                    <option value="문과">문과</option>
                    <option value="이과">이과</option>
                    <option value="network">인접학과 네트워크</option>
                </select> 
                : <div></div>
        
            }
            {upperLevel === '3'?
                <select name="시각화" onChange={(e) => formHandler(e)}>
                    <option value="1">선택하기</option>
                    <option value="지식">지식</option>
                    <option value="스킬">스킬</option>
                    <option value="흥미">흥미</option>
                    <option value="가치">가치</option>
                    <option value="개인특성">개인특성</option>
                    <option value="중요문항">중요문항</option>
                </select>
                : <div></div>
            }
        </div>
        <LoadInView>
            <div>
                <embed type='text/html' src={url} width={1600} height={1000}/>
            </div>
        </LoadInView>
    </Wrapper>
  )
}

export default Visualize

const Wrapper = styled.div`
    margin: 30px 0;
`